<template>
  <a-modal
      title="提交上架"
      :visible="visible"
      @cancel="onCancel"
      :footer="null"
      :width="795"
  >
    <div class="content-bar">
      <a-form v-bind="formItemLayout">
        <a-form-item label="商品原价:">
          <a-input placeholder="请输入" v-model="formData.cost_price"  @keyup="onKeyDownHandler"></a-input>
        </a-form-item>
        <a-form-item label="商品券额:">
          <a-input placeholder="请输入" v-model="formData.coupon_price" @keyup="onKeyDownHandler"></a-input>
        </a-form-item>
        <a-form-item label="补贴金额:">
          <a-input placeholder="请输入" v-model="formData.price"  @keyup="onKeyDownHandler"></a-input>
        </a-form-item>
        <a-form-item label="推广数量:">
          <a-input placeholder="请输入" v-model="formData.stock"  @keyup="onKeyDownHandler"></a-input>
          <tip-tool content="(商家设置好库存 如果跑超概不负责)"/>
        </a-form-item>
        <a-form-item label="补贴金额(元):" >
          <div>
            <span>服务费(元)：{{ intervalInfo.fee }}积分/单</span>
            <span style="padding: 0 20px">免单补贴:{{ intervalInfo.subsidy_price }}积分/单</span>
            <span>共需扣除:{{ intervalInfo.sum }}积分</span>
          </div>
          <div class="flex">
            <div class="flex">
              <a-icon type="info-circle" style="margin-right: 8px"></a-icon>
              积分不足
            </div>
            <a-button @click="toJumpPage" style="margin-left: 8px" class="custom-btn">去充值</a-button>
          </div>
        </a-form-item>
        <div class="btns">
          <a-button type="primary" @click="onSubmit">
            提交
          </a-button>
          <a-button style="margin-left: 10px;" @click="onReset">
            重置
          </a-button>
        </div>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import TipTool from "@/components/TipTool";
import {computedIntegralNew,  goodSubmitProductUp} from "@/api/merchant-registration";

export default {
  components: {
    TipTool
  },
  data() {
    return {
      formData: {
        gid: '',
        cost_price: '',
        coupon_price: '',
        price: '',
        stock: ''
      },
      visible: false,
      intervalInfo: {
        "fee": "0",
        "subsidy_price": "0",
        "sum": "0"
      },
      formItemLayout: {
        labelCol: {
          xs: {span: 24},
          sm: {span: 4},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
      },
    }
  },
  methods: {
    toJumpPage() {
      this.$router.push('/business/recharge')
    },
    onKeyDownHandler() {
        this._fetchComputedInterval()
    },
    _fetchComputedInterval() {
      computedIntegralNew(this.formData).then(resp => {
        this.intervalInfo = resp
      })
    },
    onReset() {
      this.onKeyDownHandler()
    },
    onSubmit() {
      if (this.formData.stock.length === 0) {
        return this.$message.warn('请输入推广数量')
      }
      goodSubmitProductUp(this.formData).then(() => {
          this.onCancel()
          this.$emit('on-refresh')
        })

    },
    show(row) {
      let newRaw = {...row}
      this.formData = newRaw.goods_info
      this.formData.stock=newRaw.stock
      console.log(this.formData)
      this._fetchComputedInterval()
      this.visible = true
    },
    onCancel() {
      this.visible = false
      this.$emit('onCancel')
    },
  },
}
</script>

<style scoped lang="scss">
.content-bar {
  padding-left: 3%;
}

.flex {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: #40A3FF;
}

.custom-btn {
  background: #37CE66;
  border-color: #37CE66;
  color: #fff;
  margin-left: 8px;
}

.btns {
  display: flex;
  margin-top: 50px;
  justify-content: center;
}
</style>
